module.exports = __webpack_public_path__ + "img/4.a268dd81.jpg";